<template>
    <div>
        <b-navbar toggleable="lg">
            <b-navbar-brand :to="{ name: 'home'}">Arkeon</b-navbar-brand>

            <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

            <b-collapse id="nav-collapse" is-nav>
                <b-navbar-nav>
                    <b-nav-item to="/gateways">Passerelles</b-nav-item>
                    <b-nav-item to="/devices">Matériels</b-nav-item>
                </b-navbar-nav>

                <!-- Right aligned nav items -->
                <b-navbar-nav class="ml-auto">
                    <b-nav-text><em>{{$root.userInfo.login}}</em></b-nav-text>
                    <b-nav-item to="/logout">Déconnexion</b-nav-item>
                </b-navbar-nav>
            </b-collapse>
        </b-navbar>
        <router-view></router-view>
    </div>
</template>

<script>
    /**
     * Component handling logged user layout
     */
    export default {
        name: "Home"
    }
</script>

<style scoped>

</style>